import { parseAsDateRangeFilter } from '@app/components/date-range-selector/date-range/parse-as-date-range-filter';
import { DateRangePreset } from '@app/components/date-range-selector/date-range/date-range-presets';
import { GenericDateRangeFilter } from '@app/core/list-view/base-filters/GenericDateRangeFilter';
import { GenericTextFilter } from '@app/core/list-view/base-filters/GenericTextFilter';
import { createFilter } from '@app/core/list-view/types';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

const AUDIOS_ALLOWED_DATE_PRESETS: DateRangePreset[] = [
  'today',
  'yesterday',
  'last24Hours',
  'last7Days',
  'last14Days',
  'last30Days',
  'thisWeek',
  'thisMonth',
  'yearToDate',
  'customSingleDate',
  'fromCustomDateUntilNow',
  'customFixedDateRange',
];

/**
 * Filters for the station audios list: preset date range (defaults to the last 7 days) and material ID text search.
 */
export const AUDIOS_LIST_FILTERS_CONFIG = [
  createFilter({
    name: 'dateRange',
    label: false,
    parser: parseAsDateRangeFilter.withDefault({ preset: 'last7Days' }),
    isPermanent: true,
    component: GenericDateRangeFilter,
    componentProps: {
      allowedPresets: AUDIOS_ALLOWED_DATE_PRESETS,
    },
  }),
  createFilter({
    name: 'customId',
    label: defineMessage({
      id: 'audit.filesUpload.audioIdLabel',
      defaultMessage: 'ID material',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      sx: {
        width: '22ch',
      },
    },
  }),
];
